import { takeEvery, put } from 'redux-saga/effects'
import { reset } from 'redux-form/immutable'

import { getProfile, saveProfile } from '../actions'
import { TIME_PREFERENCES_FORM } from 'app/constants/profile'

export function* handleUpdateProfileSuccess() {
  yield put(reset(TIME_PREFERENCES_FORM))
}

export default function* updateProfileSuccessTakeEvery() {
  yield takeEvery([getProfile.success, saveProfile.success], handleUpdateProfileSuccess)
}
